export const SITE_URL: string = import.meta.env.VITE_SITE_URL || 'https://usfanslink.baby';

export const SITE_NAME = 'USFans Spreadsheet';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

export const SITE_DESCRIPTION =
  'Explore the USFans Spreadsheet with shopping guides, USFans reviews, shipping cost info, warehouse tips, coupons and safety resources for smarter online shopping.';

export const LAST_MODIFIED = '2026-08-23';